export default __webpack_public_path__ + "static/media/Pet Black Lotus.a9ee36ae.jpg";